module.exports = __webpack_public_path__ + "media/svg/ao-59445056.svg";